export default __webpack_public_path__ + "static/media/G_D_btn__Ordini_Roll.9f284ad1.svg";